export default "__VITE_ASSET__w6of89n$__"